import { Routes } from '@angular/router';

export const PROFILE_ROUTES: Routes = [
  { path: '', redirectTo: 'personal', pathMatch: 'full' },
  {
    path: 'personal',
    loadComponent: () =>
      import('./personal-info/personal-info').then((m) => m.PersonalInfoComponent),
  },
  {
    path: 'employment',
    loadComponent: () =>
      import('./employment-status/employment-status').then((m) => m.EmploymentStatusComponent),
  },
  {
    path: 'company',
    loadComponent: () =>
      import('./company-details/company-details').then((m) => m.CompanyDetailsComponent),
  },
  {
    path: 'business',
    loadComponent: () =>
      import('./business-list/business-list').then((m) => m.BusinessListComponent),
  },
  {
    path: 'business/add',
    loadComponent: () =>
      import('./business-form/business-form').then((m) => m.BusinessFormComponent),
  },
  {
    path: 'business/:id/edit',
    loadComponent: () =>
      import('./business-form/business-form').then((m) => m.BusinessFormComponent),
  },
  {
    path: 'banking',
    loadComponent: () =>
      import('./banking-information/banking-information').then(
        (m) => m.BankingInformationComponent,
      ),
  },
  {
    path: 'notifications',
    loadComponent: () =>
      import('./notifications/notifications').then((m) => m.NotificationsComponent),
  },
  {
    path: 'invoices',
    loadComponent: () => import('./invoices/invoices').then((m) => m.InvoicesComponent),
  },
];
